import PropTypes from 'prop-types';
import Container from '@/components/Container';
import Categories from './Categories';
import PostListing from './PostListing';

const defaultProps = {
  posts: [],
  categories: [],
  currentCategory: null,
};

const propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
  categories: PropTypes.arrayOf(PropTypes.object),
  currentCategory: PropTypes.string,
};

export default function Posts({ posts, categories, currentCategory }) {
  const hasCategories = categories.length !== 0;

  return (
    <div className="bg-gray-100">
      {hasCategories && (
        <Categories categories={categories} active={currentCategory} />
      )}
      <Container className="relative z-10 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-8">
          {posts.map(({ id, ...post }, index) => (
            <div key={`${id}-${index}`} className="flex lg:col-span-4">
              <PostListing {...post} />
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}

Posts.defaultProps = defaultProps;
Posts.propTypes = propTypes;
